import { ServingEnvironment } from "@optima-stride-ai/optima-app-framework"

export const environment = {
    appName: 'benzaiten',
    displayName: 'Strategy & Goals',
    subdomain: 'benzaiten',
    appEnvironment: ServingEnvironment.uat,
    // appId: 'f97fddc2-b7ce-49c7-98f1-dfa4601798ab',
    appId: 'f97fddc2-b7ce-49c7-98f1-dfa4601798ab',
    benzaiten:{
        appServer: {
        baseURL: 'https://uat.optimastride.com',
        // baseURL: 'http://localhost:3000',
        // baseURL: 'https://proto.optimastride.com',
        extension: 'api', //api //DO NOT PUT ANY SLASHES
        version: 'v0', //v0 //DO NOT PUT ANY SLASHES
      },
      headers:{
        // tenantuuid:'9d9c1b66-9d2a-4b0b-91c0-5b02a9b56df4',
        tenantuuid:'6c57d5da-4399-4517-bffb-94d2a381e993',
        appid:'f97fddc2-b7ce-49c7-98f1-dfa4601798ab',
        userToken: 'c4abd6d5-2439-4673-b6ce-eb6ff241ab0b'
      }
    },
}

export const benzaitenAppServerURL = {
    baseURL: environment.benzaiten.appServer.baseURL,
    extension: environment.benzaiten.appServer.extension,
    version: environment.benzaiten.appServer.version
}

export const benzaitenAppHeaders = {
    tenantuuid: environment.benzaiten.headers.tenantuuid,
    appid: environment.benzaiten.headers.appid,
    userToken: environment.benzaiten.headers.userToken
}
